export default {"src":"/_next/static/media/due-today.0cd11cdd.svg","height":513,"width":513};